import { catchError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponse } from 'src/app/shared/models/api-response.model';
import { BaseService } from 'src/app/shared/services/base-service.service';
import { SearchDto1 } from 'src/app/shared/models/paging/request/search-dto';
import { getQueryString } from 'src/app/shared/helpers/query.string';
import { EmployeeProfileDto, UserDto } from '../models/user-management-models';
import { Paginator } from 'src/app/shared/models/paginator.model';
 

@Injectable({ providedIn: 'root' })
export class UserManagementService extends BaseService {
  public notificationCount: string = '0';
  public referralLandingNotificationCount: number = -1;

  constructor(private http: HttpClient) {
    super()
  }
  getUsers(params): Observable<ApiResponse<Paginator<UserDto>>> {
    let httpParams = params ? getQueryString(params) : {};
    return this.http.get<ApiResponse<Paginator<UserDto>>>( '/api/Users', { params: httpParams });
  }
  getById(id: string): Observable<ApiResponse<EmployeeProfileDto>> {
    return this.http.get<ApiResponse<EmployeeProfileDto>>( `/api/Users/${id}`);
  }
 getDataEntryUsers(): Observable<ApiResponse<Array<UserDto>>> {
  return this.http.get<ApiResponse<Array<UserDto>>>( `/api/Users/GetDataEntryUsers`);
}
  saveUser(model: any): Observable<ApiResponse<UserDto>> {
    return this.http.post<ApiResponse<UserDto>>('/api/Users', model);
  }
  updateUser(id: string,model: EmployeeProfileDto): Observable<ApiResponse<UserDto>> {
    return this.http.post<ApiResponse<UserDto>>( `/api/Users/${id}`, model);
  }
  updateStatus(id: string): Observable<ApiResponse<boolean>> {
    return this.http.post<ApiResponse<boolean>>(`/api/Users/${id}/update-status`, {});
  }

  BulkUploadUsers(any): Observable<ApiResponse<any>> {

    const formData = new FormData();
  formData.append('file', any);
  return this.http.post<ApiResponse<any>>('/api/users/BulkUploadUsers', formData);
  }

}
